import { useEffect } from 'react';

type EventHandler = (payload?: any) => void;

export function usePiralEventListener(
	piral: any,
	completeEvent: string,
	cancelEvent: string,
	completeInteraction: EventHandler,
	cancelInteraction: EventHandler
) {
	useEffect(() => {
		const completeCallback = (payload: any) => {
			completeInteraction(payload);
		};
		const cancelCallback = () => {
			cancelInteraction();
		};

		piral.on(completeEvent, completeCallback);
		piral.on(cancelEvent, cancelCallback);

		return () => {
			piral.off(completeEvent, completeCallback);
			piral.off(cancelEvent, cancelCallback);
		};
	}, [completeInteraction, cancelInteraction, piral, completeEvent, cancelEvent]);
}
